export default __webpack_public_path__ + "static/media/bloco_final_image.4664bb6a.svg";